const StateTributation = () => import('./pages/StateTributation.vue');

export default [
  {
    path: '/fiscal/state-tributation',
    name: 'StateTributation',
    component: StateTributation,
    meta: {
      title: 'Alíquotas estaduais (IBS)',
    },
  },
];
